/* eslint-disable  */
import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/AccountBox';
import MailIcon from '@mui/icons-material/TimeToLeave';
import GroupIcon from '@mui/icons-material/Group';
import RegisterForm from './customer';
import { useLocation, useNavigate } from "react-router-dom";
import { Modal,Button } from 'antd';
import { remove } from "../library/Api";
import logOut from "../assets/images/logout.svg";
import historyIcon from "../assets/images/history.svg";
import userIcon from "../assets/images/user.png";
import userTickIcon from "../assets/images/user-tick.png";
import reportIcon from "../assets/images/reportIcon.svg";
import vlogIcon from "../assets/images/logvisitor.png";
import aviSync from "../assets/images/aviSync.svg"
const drawerWidth = 240;

const zero5Icon = `data:image/svg+xml;utf8,<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path 
    d="M12 2C6.48 2 2 6.48 2 12C2 14.59 2.99 16.94 4.61 18.73L3.5 22L6.87 20.94C8.38 21.62 10.14 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z" 
    fill="white" 
    stroke="%2300aaff" 
    stroke-width="1"
  />
</svg>`;
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

export default function MiniDrawer() {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [show, setShow] = React.useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  var Mcdata = JSON.parse(localStorage.getItem("MCData"));
  const company = localStorage.getItem("company");
  const admin_id = Mcdata.admin_id
 

  const handleIconClick = () => {
    if (location.pathname === "/register") {
      navigate("/register");
    } else {
      navigate("/register");
    }
  };
  const handleIconClicks = () => {
    if (location.pathname === "/vehicleadd") {
      navigate("/vehicleadd");
    } else {
      navigate("/vehicleadd");
    }
  };
  const handleIconClickss = () => {
    if (location.pathname === "/user") {
      navigate("/user");
    } else {
      navigate("/user");
    }
  };

  const handleTenantIconClick = () => {
    if (location.pathname === "/tenant") {
      navigate("/tenant");
    } else {
      navigate("/tenant");
    }
  };
  const handleVisitorsClick = () => {
    if (location.pathname === "/visitorslog") {
      navigate("/visitorslog");
    } else {
      navigate("/visitorslog");
    }
  };
  const handlereportIconClick = () => {
    if (location.pathname === "/reports") {
      navigate("/reports");
    } else {
      navigate("/reports");
    }
  }

  const handleAvisyncIconClick = () => {
    if (location.pathname === "/avisync") {
      navigate("/avisync");
    } else {
      navigate("/avisync");
    }
  }

  const handleZero5PendingUpdatesIconClick = () => {
    if (location.pathname === "/superadmin/zero5-pending-updates") {
      navigate("/superadmin/zero5-pending-updates");
    } else {
      navigate("/superadmin/zero5-pending-updates");
    }
  }

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleShow = () => {
    setShow(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };
  const onCancelButtonClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setShow(false);
    // this.props.history.push('/retail/entry');
  };
  const onConfirmButtonClick = (e) => {

    var data = JSON.parse(localStorage.getItem("MCData"));
    // this.setState({ token: data?.token });
    // this.setState({ user: data?.userName });
    // console.log(this.state.token);
    e.stopPropagation();
    e.preventDefault();
    // const url = `apis/user_logout`;
    remove("user_logout").then((response) => {

      console.log(response);
      localStorage.clear();


    });
    

    setShow(false);

    // localStorage.clear();
     navigate("/");
    // window.location.reload();


  };
  return (
    
    <div>
      <Modal
            open={show}
            title="Logout"
            centered
            className="logout-style"
            onOk={onConfirmButtonClick}
            onCancel={onCancelButtonClick}
            footer={[
              <Button key="back" onClick={onCancelButtonClick}>
                Cancel
              </Button>,
              <Button key="submit" type="primary" onClick={onConfirmButtonClick}>
                Yes, I'm sure
              </Button>,
            ]}
          >

            <p className="text-center" style={{fontSize:'17px'}}>Are you sure you want to logout?</p>
          </Modal>
       <CssBaseline />
      <AppBar position="fixed" open={open} className="header-section">
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: 5,
              ...(open && { display: 'none' }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <div className="d-flex align-items-center justify-content-between w-100">
            <div>
            <Typography variant="h5" noWrap component="div" className="logo-style" style={{fontWeight: 500}}>
            Credential Management
          </Typography> 
            </div>
          <div className="d-flex align-items-center">
          <Typography className='me-4'>Welcome {JSON.parse(localStorage.getItem("MCData"))?.first_name}</Typography>
          <Typography variant="h5" noWrap component="div" className="logo-style">
            {/* <i class="fa-solid fa-right-from-bracket" onClick={handleShow}></i> */}
            <img src={logOut} alt="logout" onClick={handleShow} style={{width: '35px', cursor: 'pointer'}} />
          </Typography> 
          </div>
          
          </div>
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" open={open} className="main-box-sidebar">
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </DrawerHeader>
        {/* <Divider /> */}
        <List className="sidebar-style">
          {/* {['Customer', 'Vehicle'].map((text, index) => ( */}
            <>
             <ListItem key='Customer' disablePadding sx={{ display: 'block' }} className="li-style" title='Customer'>
              <ListItemButton onClick={handleIconClick}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                }}
              >
                <ListItemIcon
                className="icon-box-style"
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                  <img src={userIcon} alt="user" style={{width:'35px'}} />
                 {/* <InboxIcon className="icon-style" />  */}
                </ListItemIcon>
                <ListItemText primary='Customer' className="icon-text-style" sx={{ opacity: open ? 1 : 0 }} title='Customer'/>
              </ListItemButton>
            </ListItem>
             {/* <ListItem key="Vehicleadd" disablePadding sx={{ display: 'block' }} className="li-style">
             <ListItemButton onClick={handleIconClicks}
               sx={{
                 minHeight: 48,
                 justifyContent: open ? 'initial' : 'center',
                 px: 2.5,
               }}
             >
               <ListItemIcon
                className="icon-box-style"
                 sx={{
                   minWidth: 0,
                   mr: open ? 3 : 'auto',
                   justifyContent: 'center',
                 }}
               >
                 <MailIcon className="icon-style" />
               </ListItemIcon>
               <ListItemText primary="Vehicle" className="icon-text-style" sx={{ opacity: open ? 1 : 0 }} />
             </ListItemButton>
           </ListItem> */}
           {company==="0"?
           <ListItem key="User" disablePadding sx={{ display: 'block' }} className="li-style" title='User'>
             <ListItemButton onClick={handleIconClickss}
               sx={{
                 minHeight: 48,
                 justifyContent: open ? 'initial' : 'center',
                 px: 2.5,
               }}
             >
               <ListItemIcon
                className="icon-box-style"
                 sx={{
                   minWidth: 0,
                   mr: open ? 3 : 'auto',
                   justifyContent: 'center',
                 }}
               >
                  <img src={userTickIcon} alt="user" style={{width:'35px'}} />
                 {/* <GroupIcon className="icon-style" /> */}
               </ListItemIcon>
               <ListItemText primary="User" className="icon-text-style" sx={{ opacity: open ? 1 : 0 }} title='User'/>
             </ListItemButton>
           </ListItem>
           :""
                }
            </>



            {company==="0" && [1, 2,87].includes(admin_id) ?
           <ListItem key="Tenant" disablePadding sx={{ display: 'block' }} className="li-style" title='Tenant History'>
             <ListItemButton onClick={handleTenantIconClick}
               sx={{
                 minHeight: 48,
                 justifyContent: open ? 'initial' : 'center',
                 px: 2.5,
               }}
             >
               <ListItemIcon
                className="icon-box-style"
                 sx={{
                   minWidth: 0,
                   mr: open ? 3 : 'auto',
                   justifyContent: 'center',
                 }}
               >
                  <img src={historyIcon} alt="Tenant History" style={{width:'32px'}} />
                 {/* <GroupIcon className="icon-style" /> */}
               </ListItemIcon>
               <ListItemText primary="Tenant History" className="icon-text-style" sx={{ opacity: open ? 1 : 0 }} title='Tenant History'/>
             </ListItemButton>
           </ListItem>
           :""
                }

            
           
          {/* ))} */}

          {company==="0" && [1, 2,87].includes(admin_id) ?
           <ListItem key="reports" disablePadding sx={{ display: 'block' }} className="li-style" title='Reports'>
             <ListItemButton onClick={handlereportIconClick}
               sx={{
                 minHeight: 48,
                 justifyContent: open ? 'initial' : 'center',
                 px: 2.5,
               }}
             >
               <ListItemIcon
                className="icon-box-style"
                 sx={{
                   minWidth: 0,
                   mr: open ? 3 : 'auto',
                   justifyContent: 'center',
                 }}
               >
                  <img src={reportIcon} alt="Reports" style={{width:'30px'}} />
                 {/* <GroupIcon className="icon-style" /> */}
               </ListItemIcon>
               <ListItemText primary="Reports" className="icon-text-style" sx={{ opacity: open ? 1 : 0 }} title='Reports'/>
             </ListItemButton>
           </ListItem>
           :""
                }

            
          {/* {company==="0" && [1, 2].includes(admin_id) ?
           <ListItem key="avisync" disablePadding sx={{ display: 'block' }} className="li-style" title='AviSync'>
             <ListItemButton onClick={handleAvisyncIconClick}
               sx={{
                 minHeight: 48,
                 justifyContent: open ? 'initial' : 'center',
                 px: 2.5,
               }}
             >
               <ListItemIcon
                className="icon-box-style"
                 sx={{
                   minWidth: 0,
                   mr: open ? 3 : 'auto',
                   justifyContent: 'center',
                 }}
               >
                  <img src={aviSync} alt="AviSync" style={{width:'30px'}} />
                
               </ListItemIcon>
               <ListItemText primary="AviSync" className="icon-text-style" sx={{ opacity: open ? 1 : 0 }} title='AviSync'/>
             </ListItemButton>
           </ListItem>
           :""
                }
            {company==="0" && [1, 2].includes(admin_id) ?
           <ListItem key="avisync" disablePadding sx={{ display: 'block' }} className="li-style" title='AviSync'>
             <ListItemButton onClick={handleVisitorsClick}
               sx={{
                 minHeight: 48,
                 justifyContent: open ? 'initial' : 'center',
                 px: 2.5,
               }}
             >
               <ListItemIcon
                className="icon-box-style"
                 sx={{
                   minWidth: 0,
                   mr: open ? 3 : 'auto',
                   justifyContent: 'center',
                 }}
               >
                  <img src={vlogIcon} alt="AviSync" style={{width:'30px'}} />
                
               </ListItemIcon>
               <ListItemText primary="VisitorsLog" className="icon-text-style" sx={{ opacity: open ? 1 : 0 }} title='VisitorsLog'/>
             </ListItemButton>
           </ListItem>
           :""
                } */}
          {company==="0" && [1, 2,87].includes(admin_id) ?
           <ListItem key="zero5pendingupdates" disablePadding sx={{ display: 'block' }} className="li-style" title='Zero5 Pending Updates'>
             <ListItemButton onClick={handleZero5PendingUpdatesIconClick}
               sx={{
                 minHeight: 48,
                 justifyContent: open ? 'initial' : 'center',
                 px: 2.5,
               }}
             >
               <ListItemIcon
                className="icon-box-style"
                 sx={{
                   minWidth: 0,
                   mr: open ? 3 : 'auto',
                   justifyContent: 'center',
                 }}
               >
                  <img src={zero5Icon} alt="Zero5 Pending Updates" style={{width:'30px'}} />
               </ListItemIcon>
               <ListItemText primary="Zero5 Pending Updates" className="icon-text-style" sx={{ opacity: open ? 1 : 0 }} title='Zero5 Pending Updates'/>
             </ListItemButton>
           </ListItem>
           :""
                }




          
        </List>
       
      </Drawer>
      {/* <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader />
        <Typography paragraph>
        
        </Typography>
       
      </Box> */}
   
      </div>
  );
}